import React from 'react';
import PropTypes from 'prop-types';
import { Tab } from '@octane/spark';

const CreditSlots = ({
  slots = [],
  slotPreselected,
  preselectedCreditScoreSlot,
  onSlotSelect,
}) => {
  const getValueBySlot = (slot) => {
    return `${slot.aprLowerBound}-${slot.aprUpperBound}`;
  };

  if (!slots || slots.length === 0) {
   return null;
  }

  let initialValue;
  if (preselectedCreditScoreSlot) {
    initialValue = getValueBySlot(preselectedCreditScoreSlot);
  } else if (typeof slotPreselected === 'number') {
    initialValue = getValueBySlot(slots[slotPreselected]);
  } else {
    initialValue = getValueBySlot(slots[slots.length - 1]);
  }

  const items = slots.map(slot => {
    return {
      label: slot.label,
      value: getValueBySlot(slot),
    };
  });

  const handleOnChange = (slotValue) => {
   const [aprLowerBoundValue, aprUpperBoundValue] = slotValue.split('-');
   const selectedSlot = slots.find(
     slot =>
       slot.aprLowerBound === parseFloat(aprLowerBoundValue) &&
       slot.aprUpperBound === parseFloat(aprUpperBoundValue)
   );

   onSlotSelect(
     parseFloat(aprLowerBoundValue),
     parseFloat(aprUpperBoundValue),
     selectedSlot?.label
   );
  };

  return (
    <Tab
      items={items}
      label="Credit Rating"
      onChange={handleOnChange}
      initialValue={initialValue}
    />
  );
};

CreditSlots.propTypes = {
  slots: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      aprLowerBound: PropTypes.number.isRequired,
      aprUpperBound: PropTypes.number.isRequired
    })
  ).isRequired,
  slotPreselected: PropTypes.number,
  preselectedCreditScoreSlot: PropTypes.shape({
    label: PropTypes.string.isRequired,
    aprLowerBound: PropTypes.number.isRequired,
    aprUpperBound: PropTypes.number.isRequired
  }),
  onSlotSelect: PropTypes.func.isRequired
};

export default CreditSlots;

